<template>
  <div
    v-tooltip="`${$t('COMMON.NEW')} ${$t('DEALS.NOTES.CALL_NOTE')}`"
    data-cy="call-note"
    class="modal-icon"
    @click="emit('modal:show', $event, CommunicationType.call)"
  >
    <div class="relative flex h-full items-center justify-center">
      <icon-base :icon="IconTelephone" class="absolute top-[9px] left-[5px]" />
      <icon-base
        :icon="IconNotes"
        class="absolute top-[7px] right-[7px]"
        width="10"
        height="10"
        view-box="0 0 16 16"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CommunicationType } from "@/enums/communicationLogs";

import IconNotes from "@/components/icons/IconNotes.vue";
import IconTelephone from "@/components/icons/IconTelephone.vue";

const emit = defineEmits<{
  "modal:show": [MouseEvent, CommunicationType];
}>();
</script>
